import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as duration from 'dayjs/plugin/duration';

@Component({
  standalone: false,
  template: `{{alarmStateChanged}}`
})
export class AlarmStateChangedCellComponent implements ICellRendererAngularComp {

  alarmStateChanged: any;

  constructor() {
    dayjs.extend(relativeTime.default);
    dayjs.extend(duration.default);
  }

  agInit(params: any): void {
    this.alarmStateChanged = dayjs.default().to(dayjs.default(params.value), false)
  }

  refresh(): boolean {
    return false;
  }
}